export default __webpack_public_path__ + "static/media/congrats__top__img.a64df453.gif";